import { DocumentProviderType } from 'models/documentProvider';
import { DocumentOutputFolderRule } from 'models/documentOutputLocation';
import { KpiAttachmentLocationDTO, KpiAttachmentOverrideDTO } from 'models/dto/kpiAttachmentLocationDTO';
import KpiAttachmentLocation, {
  KpiAttachmentLocationSource,
  KpiAttachmentOverride,
} from 'models/kpiAttachmentLocation';

export function mapFromKpiAttachmentLocation(dto: KpiAttachmentLocationDTO): KpiAttachmentLocation {
  const output = new KpiAttachmentLocation();

  output.bound = dto.bound === true;
  output.reason = dto.reason;
  output.source = dto.source as KpiAttachmentLocationSource | undefined;
  output.listId = dto.listId;
  output.listName = dto.listName;
  output.listUrl = dto.listUrl;
  output.providerType = dto.providerType as DocumentProviderType | undefined;
  output.folderRule = dto.folderRule as DocumentOutputFolderRule | undefined;
  output.folderName = dto.folderName;
  output.folderDriveItemId = dto.folderDriveItemId;
  output.folderUrl = dto.folderUrl;

  return output;
}

export function mapFromKpiAttachmentOverride(dto: KpiAttachmentOverrideDTO): KpiAttachmentOverride {
  const output = new KpiAttachmentOverride();

  output.kpiId = dto.kpiId;
  output.taskTypeFieldId = dto.taskTypeFieldId;
  output.taskTypeId = dto.taskTypeId;
  output.taskTypeFamilyId = dto.taskTypeFamilyId;
  output.name = dto.name;
  output.formName = dto.formName;
  output.listId = dto.listId;
  output.listName = dto.listName;
  output.providerType = dto.providerType as DocumentProviderType | undefined;
  output.folderId = dto.folderId;
  output.folderName = dto.folderName;

  return output;
}

export function mapFromKpiAttachmentOverrides(dtos: KpiAttachmentOverrideDTO[]): KpiAttachmentOverride[] {
  return (dtos ?? []).map((dto) => mapFromKpiAttachmentOverride(dto));
}
